import * as apiUtil from '../apiUtils';
import * as apiCommon from '../apiCommon';

export async function getItemUom(app, params) {
  const { id } = params;
  const docType = 'item_uom';
  const doc = await apiCommon.getDoc(app, { id, docType });
  return doc;
}

export async function deleteItemUom(app, params) {
  const { data } = params;
  const itemUomId = data._id || data.id;
  const result = await apiCommon.deleteDoc(app, {
    id: itemUomId,
    docType: 'item_uom',
  });
  return result;
}

export async function saveItemUom(app, dataToSave) {
  const { data, user } = dataToSave;
  const itemUomData = {
    active: apiUtil.toBoolean(data.active),
    conversion_rate: data.conversion_rate,
    doc_type: 'item_uom',
    image_url: data.image_url,
    item_id: data.item_id,
    uom_id: data.uom_id,
    uom_qrcodes: data.uom_qrcodes.map((qrcode) => ({
      ...qrcode,
      item_id: data.item_id,
    })),
    uom_barcodes: data.uom_barcodes.map((barcode) => ({
      ...barcode,
      item_id: data.item_id,
    })),
  };

  const params = {
    source: data,
    doc: itemUomData,
    user,
  };
  const updatedItemUom = await apiCommon.saveDoc(app, params);
  return updatedItemUom;
}
